import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatDialogModule } from "@angular/material/dialog";

import { IconComponent } from "../icon/icon.component";
import { CloseButtonComponent } from "./close-button/close-button.component";

@NgModule({
  imports: [CommonModule, MatDialogModule],
  declarations: [IconComponent, CloseButtonComponent],
  exports: [IconComponent, CloseButtonComponent],
})
export class ButtonsModule {}
